/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetDriversResponse } from '../entities/GetDriversResponse'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { serviceDriverDTOSchema } from './service/driverDTOSchema'
import { z } from 'zod'

export const getDriversResponseSchema = z.object({
  items: z.array(z.lazy(() => serviceDriverDTOSchema)).optional(),
  total: z.number().int().optional(),
}) as unknown as ToZod<GetDriversResponse>